var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("card-header", {
            attrs: { title: _vm.$router.currentRoute.meta.title }
          }),
          _c(
            "form",
            {
              attrs: { role: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.create($event)
                }
              }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm.serverError
                      ? _c("div", { staticClass: "alert alert-danger" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                          ]),
                          _vm._v(" " + _vm._s(_vm.serverError) + " ")
                        ])
                      : _vm._e()
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("select-device-types", {
                      attrs: {
                        options: {
                          id: "device_type",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "device_type",
                          error: _vm.fieldErrors.deviceType
                        }
                      },
                      model: {
                        value: _vm.device_type,
                        callback: function($$v) {
                          _vm.device_type = $$v
                        },
                        expression: "device_type"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "build_number",
                          step: 1,
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "build_number",
                          error: _vm.fieldErrors.buildNumber
                        }
                      },
                      model: {
                        value: _vm.build_number,
                        callback: function($$v) {
                          _vm.build_number = $$v
                        },
                        expression: "build_number"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "build_version",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "build_version",
                          error: _vm.fieldErrors.buildVersion
                        }
                      },
                      model: {
                        value: _vm.build_version,
                        callback: function($$v) {
                          _vm.build_version = $$v
                        },
                        expression: "build_version"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "store_url",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "store_url",
                          error: _vm.fieldErrors.storeUrl
                        }
                      },
                      model: {
                        value: _vm.store_url,
                        callback: function($$v) {
                          _vm.store_url = $$v
                        },
                        expression: "store_url"
                      }
                    }),
                    _c("select-update-actions", {
                      attrs: {
                        options: {
                          id: "update_action",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "update_action",
                          error: _vm.fieldErrors.updateAction
                        }
                      },
                      model: {
                        value: _vm.update_action,
                        callback: function($$v) {
                          _vm.update_action = $$v
                        },
                        expression: "update_action"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-neutral btn-sm",
                          attrs: { to: { name: _vm.routePrefix + ".index" } }
                        },
                        [_c("i", { staticClass: "fa fa-arrow-left" })]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "submit", disabled: _vm.loading }
                        },
                        [
                          _vm.loading
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm"
                              })
                            : _vm._e(),
                          _c("i", { staticClass: "fa fa-save" })
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }